// localStorage key name for storing our redux store
import isFeatureFlagEnabled from '../helpers/feature-flags';
import { UIAM_FLOW } from '../types/featureFlag.types';

export const lsKeyName = 'detox-state';

const onePassLoginEndPointUrl = isFeatureFlagEnabled(UIAM_FLOW)
  ? process.env.GATSBY_UIAM_ENDURL_PARAMS
  : process.env.GATSBY_ONEPASS_ENDURL_PARAMS;
export const onePassLoginUrl =
  `${process.env.GATSBY_ONEPASS_URL}/` + onePassLoginEndPointUrl;

export const onePassLogoutUrl = `${process.env.GATSBY_ONEPASS_URL}/userLogout.action?portalTy=1`;

/**
 * number of months for service to become CI eligible.
 * defaults to 12 months
 * @type {number}
 */
export const CI_ELIGIBLE_MONTHS = process.env.GATSBY_CI_ELIGIBLE_MONTHS
  ? parseInt(process.env.GATSBY_CI_ELIGIBLE_MONTHS)
  : 12;
